function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };} /* eslint-disable react/no-multi-comp */
import React from 'react';
import { fromJS } from 'immutable';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { difference } from 'lodash';
import { Icon } from "../../UI";
import { I18NLink, Translate } from "../../I18N";

import { advancedSort } from "../../utils/advancedSort";
import { notify } from "../../Notifications/actions/notificationsActions";


import { SettingsHeader } from "./SettingsHeader";

const TranslationCtx = ({ context }) => /*#__PURE__*/
React.createElement(React.Fragment, null, /*#__PURE__*/
_jsx("div", {}, void 0,
context.type && /*#__PURE__*/
_jsx("span", { className: "item-type item-type-empty" }, void 0, /*#__PURE__*/
_jsx("span", { className: "item-type__name" }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, context.type))),



context.label && /*#__PURE__*/
_jsx(I18NLink, { to: `/settings/translations/edit/${encodeURIComponent(context.id)}` }, void 0, /*#__PURE__*/

_jsx(Translate, {}, void 0, context.label))), /*#__PURE__*/



_jsx("div", { className: "list-group-item-actions" }, void 0, /*#__PURE__*/
_jsx(I18NLink, {
  to: `/settings/translations/edit/${encodeURIComponent(context.id)}`,
  className: "btn btn-default btn-xs" }, void 0, /*#__PURE__*/

_jsx(Icon, { icon: "language" }), " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "Translate"))));





const mapStateToProps = (state) => ({
  translations: state.translations,
  languages: state.settings.collection.get('languages')
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ notify }, dispatch);

const connector = connect(mapStateToProps, mapDispatchToProps);


const TranslationsList = ({ languages, translations }) => {
  const defaultLanguage = languages.find((lang) => lang.get('default') === true).get('key');
  const trans = translations || fromJS([]);

  const defaultTranslationContexts = trans.
  find((translation) => translation.get('locale') === defaultLanguage).
  get('contexts').
  toJS();

  const contexts = advancedSort(
  defaultTranslationContexts.map((c) => _objectSpread(_objectSpread({},
  c), {}, {
    sort: `${c.type || ''} + ${c.label}` })),

  { property: 'sort' });


  const uiContexts = contexts.filter((ctx) => ctx.type === 'Uwazi UI');
  const contentContexts = difference(contexts, uiContexts);

  return /*#__PURE__*/(
    _jsx("div", { className: "settings-content without-footer" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "TranslationsList panel panel-default" }, void 0, /*#__PURE__*/
    _jsx(SettingsHeader, {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Translations")), /*#__PURE__*/

    _jsx("h5", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "System translations")), /*#__PURE__*/

    _jsx("ul", { className: "list-group relation-types" }, void 0,
    uiContexts.map((context) => {var _context$_id;return /*#__PURE__*/(
        _jsx("li", { className: "list-group-item" }, (_context$_id = context._id) === null || _context$_id === void 0 ? void 0 : _context$_id.toString(), /*#__PURE__*/
        _jsx(TranslationCtx, { context: context })));})),



    contentContexts.length > 0 && /*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx("h5", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Content translations")), /*#__PURE__*/

    _jsx("ul", { className: "list-group relation-types" }, void 0,
    contentContexts.map((context) => {var _context$_id2;return /*#__PURE__*/(
        _jsx("li", { className: "list-group-item" }, (_context$_id2 = context._id) === null || _context$_id2 === void 0 ? void 0 : _context$_id2.toString(), /*#__PURE__*/
        _jsx(TranslationCtx, { context: context })));}))))));








};

export default connector(TranslationsList);